import { REGEX_PATTERNS } from '@constants';
import * as yup from 'yup';

const validationSchema = (userExists = false) => {
  return yup.object({
    firstName: userExists
      ? yup.string()
      : yup
          .string()
          .required('Required')
          .matches(/^[^\d]*$/, 'First name cannot contain digits'),
    lastName: userExists
      ? yup.string()
      : yup
          .string()
          .required('Required')
          .matches(/^[^\d]*$/, 'Last name cannot contain digits'),
    email: userExists
      ? yup.string()
      : yup.string().email().required('Required'),
    phoneNumber: userExists
      ? yup.string()
      : yup
          .string()
          .required('Required')
          .matches(
            REGEX_PATTERNS.Phone,
            'Phone Number should follow the E.164 format, e.g. +30xxxxxxxxxx'
          ),
    role: yup.string().required('Required'),
    lang: userExists ? yup.string() : yup.string().required('Required'),
  });
};

export default validationSchema;
